import React, { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Markdown from 'markdown-it';
import { DataEntity } from '../../types/data';
import styles from './description.module.css';

type DescriptionProps = {
  description?: string;
  childrenReports?: DataEntity[];
};

function getWindowWidth() {
  const { innerWidth } = window;
  return innerWidth;
}

const md = new Markdown();

export default function Description({ description = '', childrenReports = [] }: DescriptionProps) {
  const [width, setWidth] = useState(getWindowWidth());

  const maxLength = width / 8;
  const hasChildren = childrenReports.length > 0;

  const [isCollapsed, setCollapse] = useState(true);

  useEffect(() => {
    function handleResize() {
      setWidth(getWindowWidth());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getMarkdown = () => {
    const markdown = md.render(description ?? '');
    const pattern = /a href=/g;
    return markdown.replace(pattern, 'a target="_blank" href=');
  };

  const renderСollapsableDescription = () => (
    <div className={styles.content}>
      {isCollapsed ? (
        <Fragment>
          <div
            className={`${styles.content} ${styles.content_trimmed}`}
            dangerouslySetInnerHTML={{ __html: getMarkdown() }}
          />
          <span className={styles.button} onClick={() => setCollapse(false)}>
            Read more
          </span>
        </Fragment>
      ) : (
        <Fragment>
          <div className={styles.content} dangerouslySetInnerHTML={{ __html: getMarkdown() }} />
          <span className={styles.button} onClick={() => setCollapse(true)}>
            Read less
          </span>
        </Fragment>
      )}
    </div>
  );

  const renderChildReports = () =>
    childrenReports.map((child) => (
      <Link key={child.path} to={child.path} className={styles.link}>
        {child.title}
      </Link>
    ));

  return (
    <div className={styles.root}>
      {description?.length < maxLength ? (
        <div className={styles.content} dangerouslySetInnerHTML={{ __html: getMarkdown() }} />
      ) : (
        renderСollapsableDescription()
      )}
      {hasChildren && renderChildReports()}
    </div>
  );
}
